import { FiUser, FiActivity, FiCalendar } from "react-icons/fi";

interface ReviewStepProps {
  form: {
    first_name: string;
    email: string;
    phone: string;
    type: string;
    duration_minutes: number;
  };
  selectedDate: string;
  selectedTime: string;
  accentColor: string;
}

function ReviewStep({
  form,
  selectedDate,
  selectedTime,
  accentColor,
}: ReviewStepProps) {
  return (
    <div className="space-y-5 animate-fadeIn">
      <div className="text-center mb-6">
        <h4 className="text-lg font-semibold text-black dark:text-white">
          Confirme os Dados
        </h4>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Revise as informações antes de confirmar
        </p>
      </div>

      <div className="space-y-4">
        <div className="rounded-xl border border-stroke bg-gray-50 p-4 dark:border-strokedark dark:bg-meta-4">
          <div className="flex items-start gap-3">
            <div
              className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
              style={{ backgroundColor: `${accentColor}20` }}
            >
              <FiUser size={18} style={{ color: accentColor }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400">
                Dados Pessoais
              </p>
              <p className="text-sm font-semibold text-black dark:text-white mt-1 truncate">
                {form.first_name}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-300 truncate">
                {form.email}
              </p>
              {form.phone && (
                <p className="text-sm text-gray-600 dark:text-gray-300">
                  {form.phone}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-stroke bg-gray-50 p-4 dark:border-strokedark dark:bg-meta-4">
          <div className="flex items-start gap-3">
            <div
              className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
              style={{ backgroundColor: `${accentColor}20` }}
            >
              <FiActivity size={18} style={{ color: accentColor }} />
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400">
                Atividade
              </p>
              <p className="text-sm font-semibold text-black dark:text-white mt-1">
                {form.type}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                Duração: {form.duration_minutes} minutos
              </p>
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-stroke bg-gray-50 p-4 dark:border-strokedark dark:bg-meta-4">
          <div className="flex items-start gap-3">
            <div
              className="flex h-10 w-10 items-center justify-center rounded-full flex-shrink-0"
              style={{ backgroundColor: `${accentColor}20` }}
            >
              <FiCalendar size={18} style={{ color: accentColor }} />
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-gray-500 dark:text-gray-400">
                Data e Horário
              </p>
              <p className="text-sm font-semibold text-black dark:text-white mt-1">
                {new Date(selectedDate).toLocaleDateString("pt-BR", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                às {selectedTime}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewStep;
